export const data = {
	'Seguridad de Procesos': {
		'Seguridad de Procesos': ['Reporte e Investigación de eventos no deseados', 'Seguridad de Procesos'],
		Ciberseguridad: ['Ciberseguridad'],
	},
	Operación: {
		'Operaciones de campo': ['Abrir y cerrar manualmente las válvulas', 'Ajuste y Monitoreo de Flujo o Presión', 'Operaciones de Campo', 'Envio y recibo de herramientas de limpieza e inspección (PIGs)'],
		'Operación Centralizada': ['Operaciones de Consola SCADA', 'Operación - Sistemas de detección de Fugas'],
		'Operaciones Off-shore': ['Inspección Mangueras Marinas, MBC y Cabo Hawser', 'Inspección Pre-arribo >> Preamarre', 'Amarre y Desamarre', 'Inspección de Seguridad >> Buquetanque amarrado', 'Conexión y Desconexión', 'Cargue'],
		'Operaciones de Consola Local': ['Operaciones de Consola Local'],
		'Operación Estaciones': [
			'*Operación válvulas  - B0301 *Monitoreo y Ajuste de Variables de Proceso   - B0301 *IMPO Sistema de Parada de Emergencia de la Estación  - B1396 *Entrampe/Desentrampe - Lanzamiento y segumiento a herramientas de limpieza, separadores de baches e ILI - O0023. *Operación Estación - O0003 ',
		],
	},
	Mantenimiento: {
		'Mantenimiento Estaciones': ['Mantenimiento Estaciones'],
		'Mantenimiento de líneas y Activos Off-Shore': ['Mantenimiento de líneas y Activos Off-Shore'],
		'Mantenimiento Activos Off-Shore': ['*Inspección y Mantenimiento Preventivo de Mangueras Offshore y MBC - B1622 * Inspección y Mantenimiento de los Sistemas MBM y SPM - Z0003'],
	},
	Integridad: {
		'Integridad Líneas y Ductos (incluye ductos submarinos)': [
			'Ducto de Acero al Carbono (tanto para líneas como estaciones)',
			'Tubería Submarina Rígida',
			'Vasija Trampa de Marraneo',
			'Tubería de Acero Inoxidable',
			'Tub.ace.al Carbono',
			'Tubería No Ferrosa (no transporta HC)',
			'Sistema de drenaje cerrado',
			'Inspección visual de tubería y componentes antes de su instalación',
			'Inspección visual para detectar daños mecánicos en líneas instalada',
			'Adaptar camisa de reparación tipo soldadura',
			'Perforación de la línea - Hottaps',
			'Trabajos a tubería de Línea',
			'Coordinación de intervenciones mayores de línea - Corte y Empalme/Drenaje',
			'Diseño de camisas con material compuesto',
		],
		'Integridad - Tanques y activos a presión': ['Filtro Canasto-Stra.', 'Intercambiador calor', 'Agitador / Mezclador', 'Tanques', 'Vasijas', 'Inspección Rutina a Tanques de almacenamiento', 'Inspección especializada tanques API 650', 'Mantenimiento Mayor de Tanques'],
		'Integridad - Corrosión': [
			'Cama Anódica Protección Catódica (tanto para líneas como estaciones)',
			'Rectificador de Corrosión Protección Catódica',
			'Tubería Polimérica o de Fibra Reforzada',
			'Inspección y Aplicación de recubrimientos',
			'IMPO - Sistemas de Protección Catódica',
			'Monitoreo corrosión interna',
		],
		'Herramientas Inteligentes para la integridad de ductos (ILI)': ['Herramientas Inteligentes para la integridad de ductos (ILI)'],
		'DDV y Geoamenazas': ['Detección y localización de tuberías enterradas', 'Patrullar derecho de vía o servidumbre', 'Excavación y Tapado de Tuberías'],
		'Integridad Válvulas': ['Válvulas', 'Ensamble y ajuste de uniones bridadas', 'IMPO - Dispositivos de Regulación y Alivio de Presión (PSVs, TRVs, SRVs, P/V)', 'IMPO - Válvulas & Actuadores (Disciplina mecánica)'],
		'Integridad - Infraestructura Offshore': [
			'Fijación Hawser',
			'Manifold Submarino PLEM',
			'Mangueras (flotante y submarinas)',
			'SPM Punto Múltiple de Anclaje',
			'SPM Punto Unico de Anclaje',
			'Umbilical Flexible',
			'Tablero Hidráulico',
			'Trabajos Submarinos - Válvulas operadas manualmente',
			'Torque y ensamble de componentes submarinos',
			'Mantenimiento Predictivo / Preventivo Monoboya',
		],
		Soldadura: ['Soldadura', 'Inspección visual de soldadura y puntos de soldadura'],
		'Relacionamiento y Reglamentación para Interferencias por Terceros': ['Relacionamiento y Reglamentación para Interferencias por Terceros'],
		'Integridad Ensayos No Destructivos (ENDs)': ['Inspecciones especializadas y NDTs', 'Prueba Hidrostática en Tuberías y Accesorios', 'Otras inspecciones especializadas y NDTs', 'Aseguramiento de Inspecciones especializadas y NDTs'],
		'Integridad - ILI- (Inspecciones con herramientas Inteligentes (In Line Inspection))': ['-'],
		'Integridad - Clima y Fuerzas Externas': ['-'],
		'Integridad - Daño Mecánico por Terceros Involuntarios (MDPTI)': ['-'],
		'Integridad - ENDs y Pruebas Hidrostáticas': ['-'],
		'Integridad - Tanques y Vasijas a Presión': ['Inspección visual rutinaria en servicio a Tanques de almacenamiento y relevo  - O0008'],
		'Integridad - Soldadura': ['-'],
		'Líneas y Ductos de transporte de hidrocarburos': ['-'],
	},
	Confiabilidad: {
		'Confiabilidad-Sistema Contraincendios': ['Sistema Fire&Gas (detectores HC, Flama, Humo, gases, etc)', 'Sistema contraincendios y equipos de extinción', 'Sistemas de Control Industrial Fire&Gas.'],
		'Confiabilidad-Tecnologias de la Información -Infrastructura': ['Confiabilidad-Tecnologias de la Información / Infrastructura'],
		'Confiabilidad-Activos de Medición Dinámica': ['Instrumentos del patín de medición', 'Probadores fijos y portátiles', 'Computadores de flujo (CF)', 'IMPO - equipos de control - sistemas de medición'],
		'Confiabilidad-CIO': ['CIO (SCADA, OTS, LDS, entre otros)', 'IMPO - plataforma SCADA y Sistemas de detección de Fugas'],
		'Confiabilidad-Instrumentación': ['Sistema instrumentado de seguridad - SIS', 'Instrumentación de procesos', 'IMPO -  Actuador Eléctrico (RotorK)', 'IMPO - Sistema de parada de emergencia de la Estación', 'IMPO - Dispositivos de Instrumentación'],
		'Confiabilidad-Telecomunicaciones': ['Servicios y activos de telecomunicaciones'],
		'Confiabilidad-Tecnologias de la Información -Aplicaciones': ['Confiabilidad-Tecnologias de la Información / Aplicaciones'],
		'Confiabilidad-Rotativos': [
			'MMS (sistema de protección de maquinaria)',
			'Motores',
			'Compresores',
			'Bombas',
			'Turbinas',
			'Turbocargadores',
			'Blower / Ventilador',
			'Módulo Separación',
			'IMPO - Bombas',
			'Sistemas de control electrico',
			'Actuador mecánico',
			'Generador Eléctrico',
			'Transformadores',
			'Tableros Eléctricos',
			'Filtro Armónicos',
			'Variador de Frecuencia',
			'Rectificador',
			'Puesta a Tierra',
			'SwitchGear tensión',
			'Cable línea',
			'Interruptor',
			'Seccionador',
			'UPS / Banco de Baterías',
			'Banco Condensadores',
			'Banco Resistivo',
			'Aire Acondicionado Split/Vent',
			'Motor Eléctrico',
			'Unidad Lógica de Control – Relé',
			'T Automático',
			'Panel Solar',
			'Centro de Control de motores',
			'Suministro Ininterrumpido de Potencia',
			'Iluminación Interno / Externo',
			'Actuadores eléctricos, electrohidráulico, electroneumático, neumático e hidráulico',
			'Operación de celdas de baja y media tensión',
			'IMPO - Actuadores (Disciplina eléctrica)',
			'Operaciones Electricas',
		],
		'Confiabilidad-Tecnologias de la Operación (Automatización y Control)': [
			'DCS / PLC de Procesos en Estaciones y TLUs (incluye servidores y estaciones de trabajo)',
			'RTU / PLC VÁLVULAS DE SECCIONAMIENTO',
			'IMPO - Equipos de control - PLCs/DCS/RTU',
			'IMPO - equipos de control - DCS',
			'IMPO - equipos de control - RTUs',
		],
		'Civil y Estructuras': ['Activos civiles de las líneas', 'Activos civiles de las estaciones'],
		'Integridad - Tanques y Vasijas a Presión': ['-'],
		'Confiabilidad-Tecnología de la Operación (TO)': ['-'],
		'Confiabilidad-Medición Dinámica y Estática': ['-'],
		'Confiabilidad - Eléctrica': ['-'],
		'Integridad - Líneas y Ductos de transporte de hidrocarburos': ['-'],
	},
	Diseño: {
		'SME - Diseño Procesos Industriales': ['SME/ Diseño Procesos Industriales'],
		'SME - Diseño Electrica': ['SME/ Diseño Líneas y Tanques', 'SME/ Diseño Instrumentación y Medición', 'SME/ Diseño Mecánica y Limites Operativos', 'SME / Diseño Contraincendios', 'SME/ Diseño Automatización y Control', 'SME/ Diseño Civil'],
		'SME/ Diseño Automatización y Control': ['-'],
		'SME/ Diseño Instrumentación y Medición': ['-'],
		'SME/ Diseño Mecánica Rotativa y Límites Operativos de Alta Presión de Sistemas de Transporte (LOPM)': ['-'],
		'SME/ Diseño- Civil': ['-'],
		'SME / Diseño Contraincendios ': ['-'],
		'SME - Diseño Líneas y Tanques': ['-'],
	},
};
